module.exports = __webpack_public_path__ + "img/cabinet_White.c5ba0448.png";